import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Form, Input, Menu, Modal } from "antd";

import Swal from "sweetalert2";

import partnersApi from "../../apis/Partners.api";
import { setLoading } from "../../redux/store/common/commonDuck";
import { toastAlert } from "../AlertComponent";

import EditFaqTable from "./EditFaqTable";

const EditFaq = ({ channelInfo, getInfo, user }) => {
	const dispatch = useDispatch();
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [ingredientList, setIngredientList] = useState([]);
	const [faqObj, setFaqObj] = useState({
		question: channelInfo?.frequentlyFaq?.question
			? channelInfo?.frequentlyFaq?.question
			: "",
		answer: channelInfo?.frequentlyFaq?.answer
			? channelInfo?.frequentlyFaq?.answer
			: "",
	});
	// const [faqExplain, setFaqExplain] = useState([]);
	const [faqIngredientList, setFaqIngredientList] = useState(
		channelInfo?.frequentlyFaq?.ingredientList
	);
	const [selectIngredientList, setSelectIngredientList] = useState([]);
	const [exampleModal, setExampleModal] = useState(false);
	const [example, setExample] = useState("");

	useEffect(() => {
		getCategoryList();
		// const list = [...faqIngredientList];
		// setFaqExplain([...list?.map((item) => (item.explanation))]);
	}, []);

	// useEffect(() => {
	//     if (channelInfo?.frequentlyFaq?.id) {
	//         setFaqObj({
	//             question: channelInfo?.frequentlyFaq?.question,
	//             answer: channelInfo?.frequentlyFaq?.answer
	//         })
	//         if (channelInfo?.frequentlyFaq?.ingredientList) {
	//             // const list = [...channelInfo?.frequentlyFaq?.ingredientList];
	//             // setFaqIngredientList(list);
	//             // setFaqExplain([...channelInfo?.frequentlyFaq?.ingredientList?.map((item) => (item.explanation))]);
	//         } else {
	//             setFaqIngredientList([])
	//             // setFaqExplain([])
	//         }
	//     }
	// }, [channelInfo])

	useEffect(() => {
		if (faqIngredientList?.length && ingredientList?.length) {
			let idList = faqIngredientList?.map((item) => item.id);
			let selectIngredients = ingredientList?.filter(
				(item) => !idList.includes(item.id)
			);
			setSelectIngredientList(selectIngredients);
		}
	}, [ingredientList, faqIngredientList]);

	/**
	 * 카테고리 리스트 가져오기
	 * @returns {Promise<void>}
	 */
	const getCategoryList = async () => {
		setIsLoading(true);
		let param = {
			influencerId: user.id,
		};

		const res = await partnersApi.readCategoryList(param);
		const rsq = await partnersApi.readCombinationList(param);
		if (res.code === 200 && rsq.code === 200) {
			setIngredientList(res.result.totalIngredientList);
		}
		setIsLoading(false);
	};

	const dropdownCategory = (idx) => (
		<Menu>
			{selectIngredientList?.map((item) => (
				<Menu.Item
					onClick={(e) => handleIngredient(e, idx)}
					id={"main_category"}
					key={item.id}
				>
					{item?.ingredient_name}
				</Menu.Item>
			))}
		</Menu>
	);

	/**
	 * 관련 성분 성분명 수정 (드롭다운)
	 * @param e
	 * @param idx
	 */
	const handleIngredient = (e, idx) => {
		let key = e?.key;
		let selectObj = selectIngredientList.filter(
			(item) => item.id === Number(key)
		)?.[0];
		let list = [...faqIngredientList];
		if (list[idx]) {
			list[idx] = selectObj;
		}
		// let idList = list.map((item) => (item.id));
		// let reIngredient = ingredientList.filter((item) => (!idList.includes(item.id)));
		// setIngredientList(reIngredient);
		setFaqIngredientList(list);
	};

	/**
	 * 관련 성분 추가하기
	 */
	// const handleIngredientPlus = () => {
	//     if (faqIngredientList?.length) {
	//         if (faqIngredientList.length >= 4) {
	//             // toastAlert("관련 성분은 최대 4개까지 등록할 수 있습니다.")
	//             alert("관련 성분은 최대 4개까지 등록할 수 있습니다.")
	//         } else {
	//             let lastId = faqIngredientList[faqIngredientList.length - 1]?.id;
	//             setFaqIngredientList([
	//                 ...faqIngredientList,
	//                 {id: Number(lastId) + 1}
	//             ])
	//         }
	//     } else {
	//         setFaqIngredientList([{}])
	//     }
	// }

	// const deleteIngredient = (idx) => {
	//     if (window.confirm("해당 링크를 삭제하시겠습니까?")) {
	//         let list = [...faqIngredientList];
	//         list.splice(idx, 1);
	//         setFaqIngredientList(list);
	//         console.log(list);
	//     }
	// }

	const submitFaq = async () => {
		if (faqObj?.question?.length === 0 || faqObj?.answer?.length === 0) {
			toastAlert("질문/답변을 모두 작성해주세요.");
		} else if (
			!faqIngredientList.every((ingredientInfo) =>
				Object.prototype.hasOwnProperty.call(ingredientInfo, "ingredient_id")
			)
		) {
			toastAlert("성분을 선택해주세요.");
		} else {
			let param = {
				id: channelInfo?.frequentlyFaq?.id,
				influencer_id: user?.id,
				question: faqObj?.question,
				answer: faqObj?.answer,
				ingredientList: faqIngredientList,
				updated_by: user?.id,
			};
			const res = await partnersApi.postFaqList(param);
			if (res.code === 200) {
				Swal.fire({
					customClass: "alert-custom",
					text: "성공적으로 적용되었습니다!",
					confirmButtonText: "확인",
				}).then(() => {
					getCategoryList();
					getInfo();
				});
			} else {
				toastAlert("error: 적용이 실패되었습니다.");
			}
		}
	};

	return (
		<div style={{ display: "flex", flexDirection: "column" }}>
			<div
				className={`edit-profile-channel`}
				style={{
					alignItems: "flex-start",
				}}
			>
				{/* 자주묻는 질문 */}
				<div className={`edit-channel-component`}>
					<Form>
						<div className={`form-title`}>
							<p className={`title`}>자주묻는 질문</p>
							<p
								className={`example`}
								onClick={() => {
									setExampleModal(true);
									setExample("faq");
								}}
							>
								예시
							</p>
						</div>
						{/* 질문 답변 관리 */}
						<div className={`edit-channel-component-body`}>
							<p className={`body-title`}>질문 답변 관리</p>
							<div>
								<Form.Item
									label={`질문`}
									colon={false}
									style={{
										width: "100%",
										margin: 0,
									}}
									labelAlign="left"
									labelCol={{ span: 4 }}
									wrapperCol={{ span: 22 }}
									className={`form-with-border faq-form-item`}
								>
									<Input
										type={`text`}
										placeholder={`ex) 영양제가 처음인데 어떤 영양제를 먹어야 하나요?`}
										allowClear={true}
										// defaultValue={item}
										value={faqObj.question}
										onChange={(e) =>
											setFaqObj({
												...faqObj,
												question: e.currentTarget.value,
											})
										}
										disabled={isLoading}
									/>
								</Form.Item>
								<Form.Item
									label={`답변`}
									colon={false}
									style={{
										width: "100%",
										margin: 0,
									}}
									labelAlign="left"
									labelCol={{ span: 4 }}
									wrapperCol={{ span: 22 }}
									className={`form-with-border faq-form-item`}
								>
									<Input.TextArea
										type={`text`}
										placeholder={`답변을 입력해주세요.`}
										allowClear={true}
										style={{
											minHeight: "10em",
										}}
										value={faqObj.answer}
										onChange={(e) =>
											setFaqObj({
												...faqObj,
												answer: e.currentTarget.value,
											})
										}
										disabled={isLoading}
									/>
								</Form.Item>
							</div>
						</div>
						{/* 관련 성분 */}
						<div className={`edit-channel-component-body`}>
							<p className={`body-title`}>관련 성분</p>

							<EditFaqTable
								dataSource={faqIngredientList?.map((item) => ({
									...item,
									key: item.id,
									// explanation: item?.explanation !== null ? item.explanation : ""
								}))}
								setDataSource={setFaqIngredientList}
								dropdownCategory={dropdownCategory}
							/>
						</div>
					</Form>
				</div>
			</div>

			<Button
				size={"small"}
				className={`edit-success-btn`}
				style={{
					// borderRadius: "5px",
					// width: "50%",
					margin: "1em auto",
					padding: "0.3em 1.5em",
					height: "auto",
				}}
				loading={isLoading}
				onClick={submitFaq}
			>
				적용하기
			</Button>

			<Modal
				title={`자주 묻는 질문 예시`}
				wrapClassName="sms-send-modal"
				open={exampleModal}
				centered={true}
				onCancel={() => {
					setExampleModal(!exampleModal);
				}}
				width="60%"
				footer={null}
				style={{
					maxWidth: 900,
				}}
			>
				<img
					src={`/assets/images/landing/${example}.jpg`}
					alt={`예시 모달`}
					style={{
						height: "auto",
						width: "100%",
					}}
				/>
			</Modal>
		</div>
	);
};
export default EditFaq;
